import React from 'react';

const Error = () => {
    return (
        <section id="error" className="container mt-5 py-5 text-center">
            <h1 className="mt-5 pt-5"><b>404</b></h1>
            <h5>Page Not Found</h5>
        </section>  
    );
};

export default Error;